<template>
  <div class="row mb-5">
    <div v-if="!gradients || (gradients && gradients.length < 1)" class="col-md-12 text-center mt-3">
      <EmptyState title="Oops! It's empty"
                  subtitle="There are no gradients, click the button to create one"
                  btnLink="/gradient/generator" btnText="Create a gradient">
      </EmptyState>
    </div>
    <div class="col-6 col-md-4 col-lg-3 mb-3 animate__animated animate__fadeIn" v-for="(gradient, index) in gradients"
         v-bind:key="index + 'gradient-card'">
      <router-link :to="'/user/' + user.data.uid + '/gradients/' + gradient.id">
        <div class="card card-outline w-elevation card-gradient">
          <div class="card-header text-center py-1 mt-3">
            <p class="subtitle-1 text-uppercase text-truncate mb-0" v-if="gradient.name === null">No name</p>
            <p class="subtitle-1 text-uppercase text-truncate mb-0" v-else>{{ gradient.name }}</p>
          </div>
          <div class="card-body my-0">
            <div class="gradient" v-if="gradient.color3"
                 :style="{ 'background': gradient.gradientType + '(' + gradient.gradientRotation + ',' + gradient.color1 + ',' + gradient.color2 + ',' + gradient.color3 + ')' }"></div>
            <div class="gradient" v-else
                 :style="{ 'background': gradient.gradientType + '(' + gradient.gradientRotation + ',' + gradient.color1 + ',' + gradient.color2 + ')' }"></div>

            <div class="gradient-colors-container d-flex flex-wrap justify-content-between">
              <p class="gradient-color-1 subtitle-1 mb-0" :style="{'color': gradient.color1}">
                {{ gradient.color1 }}
              </p>
              <p class="gradient-color-2 subtitle-1 mb-0" :style="{'color': gradient.color2}">
                {{ gradient.color2 }}
              </p>
              <p class="gradient-color-2 subtitle-1 mb-0" v-if="gradient.color3"
                  :style="{'color': gradient.color3}">{{ gradient.color3 }}</p>
            </div>
          </div>
        </div>
      </router-link>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import EmptyState from "@/components/empty-states/EmptyState";

export default {
  name: 'UserGradientsList',
  components: {EmptyState},
  props: [
    'gradients',
  ],
  computed: {
    ...mapGetters(['user'])
  },
}
</script>